import Text from "components/Text";
import styled from "styled-components";
import { colors } from "theme/colors";

export const Work = styled.div`
    padding: 13px 11px;
    border: 1px solid #efefef;
    border-radius: 10px;
    width: 203px;
`;

export const WorkDate = styled(Text)`
    font-size: 13px;
    font-weight: 500;
    color: ${colors.grey.primary};
`;

export const ProjectDetailsLabel = styled(WorkDate)`
    margin-top: 1rem;
    font-style: italic;
`;

export const ProjectDetails = styled(WorkDate)`
    color: ${colors.grey.primary};
`;
